module.exports = __webpack_public_path__ + "img/project_report.67540095.png";